/* eslint-disable @typescript-eslint/no-use-before-define */
import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, BreadcrumbProps } from 'components';

import FormContext from '../FormContext';

interface PageBreadcrumbsProps {
  breadcrumbRoutes: BreadcrumbProps['routes'];
}

const PageBreadcrumbs = ({ breadcrumbRoutes }: PageBreadcrumbsProps) => {
  const { isProfile } = useContext(FormContext);

  // Profile doesn't have the same flow as other instances of this page
  if (isProfile) return null;

  return (
    <Breadcrumb>
      {breadcrumbRoutes.map(({ breadcrumbName, path }) => (
        <Breadcrumb.Item key={breadcrumbName}>
          <Link to={path}>{breadcrumbName}</Link>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default PageBreadcrumbs;
